<template lang="html">
  <section class="info-activity">
    <div class="info-head">
      <span class="info-highlight">
        {{ sortedActivities.planned.length }}
        <sup>/{{ activities.length }}</sup>
      </span>
      <el-progress
        type="circle"
        color="#32353b"
        :stroke-width="4"
        :percentage="percent"
        :show-text="false"
      />
    </div>
    <div class="info-content">
      <div class="info-row">
        <div>
          <el-checkbox
            :disabled="sortedActivities.planned.length === 0"
            :value="selectPlanned"
            @change="togglePlannedSelection"
          />
          <cs-button
            outline
            icon-type="material"
            :disabled="sortedActivities.planned.length === 0"
            :icon="displayPlanned ? 'visibility' : 'visibility_off'"
            @click="togglePlannedDisplay"
          />
          <span>{{
            $tc(
              'commons.planned.choice.female',
              sortedActivities.planned.length
            )
          }}</span>
        </div>
        <div class="info-count">{{ sortedActivities.planned.length }}</div>
      </div>

      <div class="info-row">
        <div>
          <el-checkbox
            :disabled="sortedActivities.unplanned.length === 0"
            :value="selectUnplanned"
            @change="toggleUnplannedSelection"
          />
          <cs-button
            outline
            icon-type="material"
            :disabled="sortedActivities.unplanned.length === 0"
            :icon="
              unplannedRoute.displayMarkers ? 'visibility' : 'visibility_off'
            "
            @click="toggleUnplannedDisplay"
          />
          <span>{{
            $tc(
              'commons.unplanned.choice.female',
              sortedActivities.unplanned.length
            )
          }}</span>
        </div>
        <div class="info-count">{{ sortedActivities.unplanned.length }}</div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
  concat,
  differenceBy,
  filter,
  flatMap,
  get,
  groupBy,
  round,
  some,
  toSafeInteger,
} from 'lodash';

export default {
  props: {
    routes: {
      type: Array,
      default: () => [],
    },
    unplannedRoute: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({}),
  computed: {
    ...mapGetters(['selection']),
    activities() {
      return concat(
        flatMap(this.realRoutes, 'deliveries'),
        this.unplannedRoute.deliveries
      );
    },
    sortedActivities() {
      const groups = groupBy(this.activities, ['route_id', null]);
      return {
        unplanned: get(groups, true, []),
        planned: get(groups, false, []),
      };
    },
    realRoutes() {
      return filter(this.routes, 'id');
    },
    percent() {
      const percent =
        (this.sortedActivities.planned.length / this.activities.length) * 100;
      return toSafeInteger(round(percent));
    },
    selectPlanned() {
      return (
        this.sortedActivities.planned.length > 0 &&
        this.diffPlanned.length === 0
      );
    },
    selectUnplanned() {
      return (
        this.sortedActivities.unplanned.length > 0 &&
        this.diffUnplanned.length === 0
      );
    },
    diffPlanned() {
      return differenceBy(
        this.sortedActivities.planned,
        this.selection.data,
        'id'
      );
    },
    diffUnplanned() {
      return differenceBy(
        this.sortedActivities.unplanned,
        this.selection.data,
        'id'
      );
    },
    displayPlanned() {
      return !some(this.realRoutes, ['displayMarkers', false]);
    },
    displayUnplanned() {
      return this.unplannedRoute.displayMarkers;
    },
  },
  methods: {
    ...mapActions([
      'addActivitiesToSelection',
      'removeActivitiesFromSelection',
    ]),
    togglePlannedSelection(v) {
      if (v) {
        this.addActivitiesToSelection({ data: this.diffPlanned });
      } else {
        this.removeActivitiesFromSelection({
          data: this.sortedActivities.planned,
        });
      }
    },
    togglePlannedDisplay() {
      const display = !this.displayPlanned;
      this.realRoutes.forEach((r) => {
        r.displayMarkers = display;
        r.displayPolyline = display;
      });
    },
    toggleUnplannedSelection(v) {
      if (v) {
        this.addActivitiesToSelection({ data: this.diffUnplanned });
      } else {
        this.removeActivitiesFromSelection({
          data: this.sortedActivities.unplanned,
        });
      }
    },
    toggleUnplannedDisplay() {
      this.$set(this.unplannedRoute, 'displayMarkers', !this.displayUnplanned);
    },
  },
};
</script>

<style lang="scss"></style>
